import { useNavigate } from "react-router-dom"

import { ThemeProvider } from "@mui/material"

import {
  customTheme,
  MetricGoalsHeaderMid,
  MetricHeaderLeft,
  MetricHeaderRight,
} from "./Atom"
import { useDispatch, useSelector } from "react-redux"
import { HeaderInfoNav } from "../Reusable"
import { MetricHeaderWrapper } from "../Atom"
import { ProvidersHeaderGeneralDropdownFilter } from "../../Dropdown/ProvidersHeaderDropdownFilter"
import {
  setOpportunitySelectedAdvisors,
  setOpportunitySelectedGroups,
  setOpportunitySelectedPractices,
  setOpportunitySelectedRegions,
  setOpportunitySelectedStatuses,
} from "../../../redux/slices/opportunitySlice"
import { setMaevaSelectedGroupsNoAll } from "../../../redux/slices/metricSlice"

export type Anchor = "top" | "left" | "bottom" | "right"

export default function OpportunityDashboardHeader({ name }: any) {
  const dispatch = useDispatch()

  const navigate = useNavigate()

  const handleClickBack = (e: any) => {
    navigate(-1)
  }

  const loading = useSelector((state: any) => {
    return state.app.loading
  })
  const opportunityAdvisors = useSelector((state: any) => {
    return state.opportunity.opportunityAdvisors
  })
  const opportunityGroups = useSelector((state: any) => {
    return state.opportunity.opportunityGroups
  })
  const opportunityRegions = useSelector((state: any) => {
    return state.opportunity.opportunityRegions
  })
  const opportunityPractices = useSelector((state: any) => {
    return state.opportunity.opportunityPractices
  })
  const opportunityStatuses = useSelector((state: any) => {
    return state.opportunity.opportunityStatuses
  })
  const opportunitySelectedAdvisor = useSelector((state: any) => {
    return state.opportunity.opportunitySelectedAdvisors?.[0]
  })
  const opportunitySelectedGroup = useSelector((state: any) => {
    return state.metric.maevaSelectedGroupsNoAll?.[0]
  })
  const opportunitySelectedRegion = useSelector((state: any) => {
    return state.opportunity.opportunitySelectedRegions?.[0]
  })
  const opportunitySelectedPractice = useSelector((state: any) => {
    return state.opportunity.opportunitySelectedPractices?.[0]
  })
  const opportunitySelectedStatus = useSelector((state: any) => {
    return state.opportunity.opportunitySelectedStatuses?.[0]
  })

  const handleAdvisorFilter = (event: any) => {
    const {
      target: { value },
    } = event
    dispatch(setOpportunitySelectedAdvisors([value]))
  }
  const handleGroupFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setMaevaSelectedGroupsNoAll([value]))
    
    dispatch(
      setOpportunitySelectedRegions([
        { label: "All", region: "all", name: "all" },
      ]),
    )
    dispatch(
      setOpportunitySelectedPractices([
        { label: "All", name: "all", practice_sk: "all" },
      ]),
    )
  }

  const handleRegionFilter = (event: any) => {
    const {
      target: { value },
    } = event
    dispatch(setOpportunitySelectedRegions([value]))
    dispatch(
      setOpportunitySelectedPractices([
        { label: "All", name: "all", practice_sk: "all" },
      ]),
    )
  }

  const handlePracticeFilter = (event: any) => {
    const {
      target: { value },
    } = event
    dispatch(setOpportunitySelectedPractices([value]))
  }

  const handleStatusFilter = (event: any) => {
    const {
      target: { value },
    } = event
    dispatch(setOpportunitySelectedStatuses([value]))
  }

  return (
    <>
      <ThemeProvider theme={customTheme}>
        <MetricHeaderWrapper>
          <MetricHeaderLeft>
            <HeaderInfoNav name={name} handleClickBack={handleClickBack} />
          </MetricHeaderLeft>

          <MetricGoalsHeaderMid>
            <ProvidersHeaderGeneralDropdownFilter
              id={1}
              key={"op-filter-1"}
              disabled={loading}
              handleFilter={handleAdvisorFilter}
              filterData={opportunityAdvisors}
              headerLabel="Advisor"
              value={opportunitySelectedAdvisor}
              placeholder="Select an Advisor"
            />
            <ProvidersHeaderGeneralDropdownFilter
              id={2}
              key={"op-filter-2"}
              disabled={loading}
              handleFilter={handleGroupFilter}
              filterData={opportunityGroups}
              headerLabel="Group Name"
              value={opportunitySelectedGroup}
              placeholder="Select a Group"
            />
            <ProvidersHeaderGeneralDropdownFilter
              id={3}
              key={"op-filter-3"}
              disabled={!opportunitySelectedGroup || loading}
              handleFilter={handleRegionFilter}
              filterData={opportunityRegions}
              headerLabel="Region Name"
              value={opportunitySelectedRegion}
              placeholder="Select a Region"
            />
            <ProvidersHeaderGeneralDropdownFilter
              id={4}
              key={"op-filter-4"}
              disabled={!opportunitySelectedRegion || loading}
              handleFilter={handlePracticeFilter}
              filterData={opportunityPractices}
              headerLabel="Practice Name"
              value={opportunitySelectedPractice}
              placeholder="Select a Practice"
            />
            <ProvidersHeaderGeneralDropdownFilter
              id={5}
              key={"op-filter-5"}
              disabled={loading}
              handleFilter={handleStatusFilter}
              filterData={opportunityStatuses}
              headerLabel="Status"
              value={opportunitySelectedStatus}
              placeholder="Select a Status"
            />
          </MetricGoalsHeaderMid>

          <MetricHeaderRight></MetricHeaderRight>
        </MetricHeaderWrapper>
      </ThemeProvider>
    </>
  )
}
